import { render, staticRenderFns } from "./fc3d.vue?vue&type=template&id=2bb329c3"
import script from "./fc3d.vue?vue&type=script&lang=js"
export * from "./fc3d.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports